/* Atlas PLP card: colour swatches swap the image, quick add (size picker), added state.
   Delegated, so cards appended by "Load more" or re-rendered by filtering keep working.
   Used by snippets/atlas-plp-card.liquid. Adding opens Pitch's cart drawer through window.Atlas.cart (atlas-runtime.js). */
(function () {
  if (window.__atlasPlpCard) return;
  window.__atlasPlpCard = true;

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const timers = new WeakMap();

  function setImg(img, url) {
    if (!img || !url) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  function pickColor(card, sw) {
    const ci = sw.dataset.ci;
    card.dataset.ci = ci;
    $$('[data-plp-swatch]', card).forEach((b) => {
      const on = b === sw;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    setImg($('.plp-card__img--a', card), sw.dataset.img);
    setImg($('.plp-card__img--b', card), sw.dataset.hover || sw.dataset.img);
    /* photo slider: jump to that colour's photo */
    const track = $('[data-plp-track]', card);
    const slide = track && sw.dataset.pos && $('.plp-card__slide[data-pos="' + sw.dataset.pos + '"]', track);
    if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    $$('.plp-card__sizes', card).forEach((g) => g.classList.toggle('is-on', g.dataset.ci === ci));
    $$('[data-plp-link]', card).forEach((a) => {
      const base = a.dataset.baseUrl;
      if (base && sw.dataset.variant) a.href = base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + sw.dataset.variant;
    });
  }

  /* spinner in the clicked size until the cart confirms, then the added state */
  function addToCart(card, btn) {
    const A = window.Atlas;
    if (!A || !A.cart || card.classList.contains('is-busy')) return;
    card.classList.add('is-busy');
    btn.classList.add('is-loading');
    A.cart.add([{ id: Number(btn.dataset.variantId), quantity: 1 }], { open: true })
      .then(() => {
        card.classList.remove('is-q');
        card.classList.add('is-added');
        clearTimeout(timers.get(card));
        timers.set(card, setTimeout(() => card.classList.remove('is-added'), 1600));
      })
      .catch(() => {})
      .then(() => { card.classList.remove('is-busy'); btn.classList.remove('is-loading'); });
  }

  /* photo slider (collection page cards): arrows step one photo; dots and arrows follow the scroll */
  function slideState(track) {
    const card = track.closest('.plp-card');
    if (!card) return;
    const w = track.clientWidth || 1;
    const i = Math.round(track.scrollLeft / w);
    const last = track.children.length - 1;
    $$('.plp-card__dots span', card).forEach((d, k) => d.classList.toggle('is-on', k === i));
    const prev = $('[data-plp-step="-1"]', card), next = $('[data-plp-step="1"]', card);
    if (prev) prev.hidden = i <= 0;
    if (next) next.hidden = i >= last;
  }
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (t && t.matches && t.matches('[data-plp-track]')) slideState(t);
  }, true);

  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-plp-step]');
    if (step) {
      e.preventDefault(); e.stopPropagation();
      const track = $('[data-plp-track]', step.closest('.plp-card'));
      if (track) track.scrollBy({ left: track.clientWidth * parseInt(step.dataset.plpStep, 10), behavior: 'smooth' });
      return;
    }
    const sw = e.target.closest('[data-plp-swatch]');
    if (sw) { e.preventDefault(); pickColor(sw.closest('.plp-card'), sw); return; }

    const plus = e.target.closest('[data-plp-plus]');
    if (plus) {
      e.preventDefault(); e.stopPropagation();
      $$('.plp-card.is-q').forEach((c) => c.classList.remove('is-q'));
      plus.closest('.plp-card').classList.add('is-q');
      return;
    }

    const qs = e.target.closest('.plp-qs');
    if (qs) {
      e.preventDefault(); e.stopPropagation();
      if (qs.classList.contains('is-oos') || qs.getAttribute('aria-disabled') === 'true') return;
      addToCart(qs.closest('.plp-card'), qs);
    }
  });

  /* Prototype: leaving the card closes an opened quick-add */
  document.addEventListener('mouseleave', (e) => {
    if (e.target && e.target.classList && e.target.classList.contains('plp-card')) e.target.classList.remove('is-q');
  }, true);
})();
